import React, { useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { WithLogout, WithLogoutProps } from '../../../oidc-client/WithLogout';
import { AppState } from '../../../store';
import { useAppSelector } from '../../hooks/redux-hooks';

const SessionTimeout: React.FC<WithLogoutProps> = ({ onLogout }) => {
    const WARNING_VISIBLE_MINUTES = 1;

    const [showModal, setShowModal] = useState(false);
    const user = useAppSelector((state: AppState) => state.authReducer?.authentication.user);

    useEffect(() => {
        if (user) {
            const expiresAt = user.expires_at * 1000;
            const currentTime = Date.now();
            const timeUntilExpiration = expiresAt - currentTime;

            const sessionExpiredCheck = () => {
                const currentTime = Date.now();
                const timeUntilExpiration = expiresAt - currentTime;

                if (timeUntilExpiration <= 2000) { 
                    onLogout();
                }
            };

            const intervalId = setInterval(sessionExpiredCheck, 1000);

            const idleTimeout = setTimeout(() => {
                setShowModal(true);
            }, timeUntilExpiration - WARNING_VISIBLE_MINUTES * 60 * 1000);

            return () => {
                clearInterval(intervalId);
                clearTimeout(idleTimeout);
            };
        }
    }, [user, onLogout]);

    useEffect(() => {
        if (showModal) {
            const logoutTimeout = setTimeout(() => {
                onLogout();
            }, 60 * 1000); 

            return () => clearTimeout(logoutTimeout);
        }
    }, [showModal, onLogout]);


    return (
        <Modal show={showModal} onHide={onLogout} backdrop="static">
            <Modal.Header>
                <Modal.Title>Session Timeout</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>Your session is expired. Please login Again.</p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={onLogout}>Login</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default WithLogout(React.memo(SessionTimeout));